import axios, { AxiosResponse } from 'axios';

import URLHelper from 'app/src/data/models/utils/URLHelper';
import { OpenOrder, OpenOrdersData } from 'root/apps/QuoteMachineIntegration/state/OpenOrdersData';
import { OpenOrdersType } from 'root/apps/QuoteMachineIntegration/state/OpenOrdersType';

export default class CustomerService {
  static async getCustomer(customerId: string): Promise<Customer | null> {
    const accountID = window.merchantos.account.id;

    try {
      const response = await axios.get(`/API/V3/Account/${accountID}/Customer/${customerId}.json`, {
        params: {
          load_relations: '["Contact"]',
        },
      });
      return response?.data?.Customer;
    } catch (error) {
      return null;
    }
  }

  static getOpenOrders(customerId: string): Promise<AxiosResponse<OpenOrdersData>> {
    return axios.get<OpenOrdersData>(
      `${URLHelper.getAccountURL('/Customer')}/${customerId}/OpenOrders.json`
    );
  }

  static async getOpenOrdersOfType(customerId: string, type: OpenOrdersType): Promise<OpenOrder[]> {
    const orders = await CustomerService.getOpenOrders(customerId);
    return orders.data.OpenOrders.filter((order) => order.type === type);
  }
}
